// import i18n from '@/i18n'
import {createLogger} from './log'

import {StoreEvents, storeEventLister} from './event-dispatcher'

const logger = createLogger('FbPixel-Subscriber', '📊', false)

export const createFBPListeners = (fbPixelEnabled, fbp) => {
  console.log(fbPixelEnabled, fbp)

  let subscribers = []
  if (fbPixelEnabled) {
    //track add to cart
    subscribers.push(
      storeEventLister(StoreEvents.PRODUCT_ADDED, m => {
        const cartItem = m.payload

        logger.print('PRODUCT_ADDED', cartItem)

        try {
          fbp.event('AddToCart')
        } catch (err) {
          logger.error('Failed PRODUCT_ADDED', err)
        }
      }),
    )

    //track purchase
    subscribers.push(
      storeEventLister(StoreEvents.CHECKOUT_ORDER_CLOSED, m => {
        const order = m.payload

        logger.print('CHECKOUT_ORDER_CLOSED', order)

        try {
          fbp.event('Purchase', {
            value: order.orderItems.reduce((a, c) => a + c.total, 0.0),
            currency: order.currency,
          })
        } catch (err) {
          logger.error('Failed ORDER_CLOSED', err)
        }
      }),
    )
  }
  return subscribers
}
